import React from 'react';

const Footer = () => (
  <>
    <h4 className="footer-title darker-bg">Project by Hernán Zamora 2023 ©</h4>
  </>
);

export default Footer;
